import reduxApi from 'redux-api';
import customFetch from 'api/axios';
import { API_URL } from 'constants/config';

// Example
export default reduxApi({

  getThoiHanXuLyMacDinh: {
    url: `${API_URL}/dons/ngayMacDinhThoiHanXuLyDon`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },

  getTongDonDinhKy: {
    url: `${API_URL}/soTiepCongDan/layTongSoDonSoTiepCongDanDinhKy`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },

  getTongDonDotXuat: {
    url: `${API_URL}/soTiepCongDan/layTongSoDonSoTiepCongDanDotXuat`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },

  getTongDonYeuCauGapLanhDao: {
    url: `${API_URL}/soTiepCongDan/layTongSoDonDanhSachYeuCauGapLanhDao`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getTongDonXLD: {
    url: `${API_URL}/dons/layTongSoDonDangXuLy`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getTongDonGQD: {
    url: `${API_URL}/dons/layTongSoDonDangGiaiQuyet`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getTongDonTDTH: {
    url: `${API_URL}/dons/layTongSoDonDangTGTH`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },

  getThoiHanTTXMMacDinh: {
    url: `${API_URL}/dons/ngayMacDinhThoiHanTTXM`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },

  getThoiHanGQDonMacDinh: {
    url: `${API_URL}/dons/ngayMacDinhThoiHanGiaiQuyetDon`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },

  getThoiGianHienTai: {
    url: `${API_URL}/layNgayGioHienTai`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },

  getHuongXuLyTheoDon: {
    url: `${API_URL}/huongXuLys/don?page=0&size=1000&sort=ten,desc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getCoQuanTiepNhan: {
    url: `${API_URL}/coQuanQuanLys/coQuanTiepNhans?page=0&size=1000&sort=ten,asc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDiaBanTiepNhan: {
    url: `${API_URL}/coQuanQuanLys/coQuanTiepNhanGiamSatTraCuus`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getPhongBanThuocCoQuan: {
    url: `${API_URL}/coQuanQuanLys/phongBansTheoDonVi`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getCoQuanQuanLy: {
    url: `${API_URL}/coQuanQuanLys/donViQuyTrinhs?page=0&size=1000&sort=ten,desc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getCoQuanQuanLytheoDV: {
    url: `${API_URL}/coQuanQuanLys/vaiTro?page=0&size=1000&sort=ten,desc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getCapDonViQuyTrinhs: {
    url: `${API_URL}/capDonViQuyTrinhs`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getChuyenVienThuocPhongBan: {
    url: `${API_URL}/congChucs/vaiTro`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCapTinhThanhPho: {
    url: `${API_URL}/donViHanhChinhs/capTinhThanhPho?page=0&size=1000&sort=ten,asc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getCapQuanHuyen: {
    url: `${API_URL}/donViHanhChinhs/capQuanHuyen?page=0&size=1000&sort=ten,asc&cha=:id`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getQuocTich: {
    url: `${API_URL}/quocTichs/combobox`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getNoiCap: {
    url: `${API_URL}/coQuanQuanLys/noiCapCMNDs?page=0&size=1000&sort=ten,asc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getCapPhuongXa: {
    url: `${API_URL}/donViHanhChinhs/capPhuongXa?page=0page&size=1000&sort=ten,asc&cha=:id`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getDanToc: {
    url: `${API_URL}/danTocs?page=0&size=1000&sort=ten,asc&cha=:id`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getLoaiDoiTuong: {
    url: `${API_URL}/loaiDoiTuongs?page=0&size=1000&sort=ten,asc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getLinhVucDonThu: {
    url: `${API_URL}/linhVucDonThuCombobox?page=0&size=1000`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getNhomThamQuyenGiaiQuyet: {
    url: `${API_URL}/thamQuyenGiaiQuyets?page=0&size=1000`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getNhomThamQuyenCombobox: {
    url: `${API_URL}/thamQuyenGiaiQuyetsCombobox`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getCapCoQuanDaGiaiQuyet: {
    url: `${API_URL}/capCoQuanQuanLys/capCoQuanDaGiaiQuyets?page=0&size=1000&sort=ten,asc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getLoaiVuViec: {
    url: `${API_URL}/vuViecs?page=0&size=1000&sort=ten,asc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getCoQuanDaGiaiQuyet: {
    url: `${API_URL}/coQuanQuanLys/coQuanDaGiaiQuyets?page=0&size=1000&sort=ten,asc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getHinhThucDaGiaiQuyet: {
    url: `${API_URL}/hinhThucDaGiaiQuyet?page=0&size=1000&sort=ten,asc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getIdThanhPhoDN: {
    url: `${API_URL}/thamSos?tuKhoa=DVHC_TP_DA_NANG`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getTinhTrangGiaiQuyet: {
    url: `${API_URL}/tinhTrangGiaiQuyets?page=0&size=1000&sort=ten,asc`,
    options: (url, params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getDonViChuTri: {
    url: `${API_URL}/coQuanQuanLys/donViChuTris?page=0&size=1000&sort=ten,asc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },

  getCapDonViHanhChinh: {
    url: `${API_URL}/capDonViHanhChinhs`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getHuongGiaiQuyetLD: {
    url: `${API_URL}/huongGiaiQuyetCuaLanhDaoTCDs?page=0&size=1000&sort=ngayTao,asc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getDonViTTXM: {
    url: `${API_URL}/coQuanQuanLys/donViChuTris?page=0&size=1000&sort=ten,asc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getTruongDoanTTXM: {
    url: `${API_URL}/congChucs/truongDoanTTXMs?page=0&size=1000&sort=ten,asc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getKetLuanNoiDungKhieuNai: {
    url: `${API_URL}/ketLuanNoiDungKhieuNais?page=0&size=1000&sort=ten,asc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getHinhThucTheoDoi: {
    url: `${API_URL}/hinhThucTheoDois?page=0&size=1000&sort=ten,asc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getKetQuaThucHien: {
    url: `${API_URL}/ketQuaThucHiens?page=0&size=1000&sort=ten,asc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getListLanhDao: {
    url: `${API_URL}/lanhDaoTiepCongDans?page=0&size=1000`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getLoaiDungDon: {
    url: `${API_URL}/phanLoaiNguoiDungDons?page=0&size=1000&sort=ten,asc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getTinhTrangTaiLieu: {
    url: `${API_URL}/tinhTrangTaiLieus`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getLoaiTepDK: {
    url: `${API_URL}/loaiTepDinhKems?page=0&size=1000&sort=ngayTao,asc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getDonViHanhChinh: {
    url: `${API_URL}/donViHanhChinhs?page=0&size=1000&sort=ten,asc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getCoQuanTiepDan: {
    url: `${API_URL}/coQuanQuanLys/danhSachCoQuanCungThamGiaTiepDanComboBox?page=0&size=1000&sort=ten,asc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getTrangThaiDon: {
    url: `${API_URL}/trangThaiDonToanHTs?page=0&size=1000&sort=ten,asc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getKetQuaGiaiQuyet: {
    url: `${API_URL}/ketQuaGiaiQuyetToanHTs?page=0&size=1000&sort=ten,asc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getKetQuaGiaiQuyetDon: {
    url: `${API_URL}/ketQuaGiaiQuyetTheoDons?page=0&size=1000&sort=ten,asc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getLoaiKyThongKe: {
    url: `${API_URL}/thongKeBaoCao/loaiKy?page=0&size=1000&sort=ten,asc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getLoaiThongKe: {
    url: `${API_URL}/enumerations/statistic-types`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getLoaiQuyThongKe: {
    url: `${API_URL}/enumerations/quarters`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getDonViThongKe: {
    url: `${API_URL}/coQuanQuanLys/donViThongKes?page=0&size=1000&sort=ten,asc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getNamThongKe: {
    url: `${API_URL}/thongKeBaoCao/years?page=0&size=1000&sort=ten,asc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getThangThongKe: {
    url: `${API_URL}/enumerations/months`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getKetQuaGiaiQuyetLanHai: {
    url: `${API_URL}/ketQuaGiaiQuyetLan2s?page=0&size=1000&sort=ten,asc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getCoQuanDieuTra: {
    url: `${API_URL}/coQuanQuanLys/coQuanDieuTras?page=0&size=1000&sort=ten,asc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getDonViTTXMNew: {
    url: `${API_URL}/coQuanQuanLys/donViNhanTTXMs?page=0&size=1000`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  checkHanGiaiQuyet: {
    url: `${API_URL}/dons/validateThoiHan`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getThamSoHeThong: {
    url: `${API_URL}/thamSoMulti`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getTongSoDon: {
    url: `${API_URL}/dons/layTongSoDon`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getLoaiThongTinDon: {
    url: `${API_URL}/loaiThongTinDon`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getQuanHuyen: {
    url: `${API_URL}/donViHanhChinhs/capQuanHuyen`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getPhuongXa: {
    url: `${API_URL}/donViHanhChinhs/capPhuongXa`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getNamThanhTra: {
    url: `${API_URL}/namThanhTras`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  }
}).use('fetch', customFetch);



// WEBPACK FOOTER //
// ./src/api/duLieuHeThong.js